import { BLUE_GREY_200, getTestId, GREEN_500 } from '@airtel/air-design-system';
export var NumberSelectionConfig = Object.assign({
  state: 'none',
  isExpanded: false,
  autoFormSubmitDebounceDelay: 800,
  isAutoFormSubmitDebounceAllowed: false,
  withCollapsible: false,
  selectedChipIndex: 2,
  chipsList: [{
    label: '9440XXXX55',
    isSelected: true
  }, {
    label: '9440XXXX55'
  }, {
    label: '9440XXXX55'
  }, {
    label: '9440XXXX55'
  }, {
    label: '9440XXXX55'
  }, {
    label: '9440XXXX55'
  }],
  buttonWidgetData: {
    direction: 'column',
    leftCta: {
      title: 'Confirm & Proceed',
      buttonType: 'primary'
    },
    rightCta: {
      title: 'View More Numbers',
      buttonType: 'tertiary'
    },
    onLeftCtaPress: {
      id: 'left-cta'
    },
    onRightCtaPress: {
      id: 'right-cta'
    }
  },
  onChipPressMetaData: {
    id: 'chip-press',
    actions: []
  },
  stepDetailsProps: {
    title: 'STEP 4',
    heading: 'Select number',
    avatarIcon: 'ContactsButtonIcon',
    avatarProps: {
      style: {
        backgroundColor: BLUE_GREY_200
      }
    },
    actionType: 'button',
    actionTypeProps: {
      buttonText: 'Change'
    },
    actionTypePosition: 'center'
  }
}, getTestId('ChipsGroupWidgetContainer'));
export var successAvatarConfig = {
  avatarIcon: 'TickButtonIcon',
  avatarProps: {
    style: {
      backgroundColor: GREEN_500
    }
  }
};